import { useCallback, useMemo, useState } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';

interface Params {
  onSubmit?: () => void;
}
const useAdaptiveFilter = ({ onSubmit }: Params) => {
  const [filterTypes, setFilterTypes] = useState<OptionKey[]>([ALL_OPTION_KEY]);
  const [filterDates, setFilterDates] = useState<[Date | null, Date | null]>([null, null]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const handleCancelFilter = useCallback(() => {
    setIsFilterVisible(false);
  }, []);
  const handleSubmitFilter = useCallback(() => {
    if (onSubmit) {
      onSubmit();
    }
    setIsFilterVisible(false);
  }, [onSubmit]);

  const handleResetFilter = useCallback(() => {
    setFilterTypes([ALL_OPTION_KEY]);
    setFilterDates([null, null]);
    if (onSubmit) {
      onSubmit();
    }
  }, [onSubmit]);

  const isFilterApplied = useMemo(() => {
    return (
      (filterTypes.length > 0 && filterTypes[0] !== ALL_OPTION_KEY) || !!filterDates[0] || !!filterDates[1]
    );
  }, [filterDates, filterTypes]);
  const handleSetFilterTypes = useCallback((keys: OptionKey[]) => {
    if (keys.length === 0) {
      return;
    }
    setFilterTypes(keys);
  }, []);
  return {
    isFilterVisible,
    setIsFilterVisible,
    filterTypes,
    setFilterTypes: handleSetFilterTypes,
    filterDates,
    setFilterDates,
    handleCancelFilter,
    handleSubmitFilter,
    isFilterApplied,
    handleResetFilter,
  };
};
export default useAdaptiveFilter;
